import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _EyeLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M12 5C6.556 5 3.53 9.234 2.455 11.116c-.22.386-.33.58-.318.868s.142.476.4.852C3.819 14.694 7.295 19 12 19s8.182-4.306 9.462-6.164c.26-.376.39-.564.401-.852s-.098-.482-.319-.868C20.47 9.234 17.444 5 12 5Z" }),
            React.createElement("path", { stroke: "currentColor", d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })));
}
const EyeLight = forwardRef(_EyeLight);
export { EyeLight };
